import $ from 'jquery';
import Vars from '../../vars';
import Action from "../classes/DropzoneAction";

import Facade from "../modules/Facade";
import Modal from "../../components/Modal";
import Request from "../../components/request";
import Utils from "../../components/utils";

export default {
    _state : {
        items : {}
    },

    _args : {
        item     : {},
        entities : ''
    },

    _setArgs : function(args) {
        let self = this;

        self._args.item     = args.item ? args.item : self._args.item;
        self._args.entities = args.entities ? args.entities : self._args.entities;
        self._args.response = args.response;
    },

    _bindUI : function() {
        let $form = $('#social-vk-params-form');
        $form.find('.dz-image').unbind('click').on('click', function(){
            let $image = $(this);
            if ($image.hasClass('disabled')) return;
            if ($image.hasClass('selected')) {
                $image.removeClass('selected');
                $form.find('input[name="compilation[image]"]').val('');
            }
            else {
                $form.find('.dz-image').each(function(){
                    $(this).removeClass('selected');
                });
                $image.addClass('selected');

                $('#social-vk-params-form input[name="compilation[image]"]').val($image.data('path'));
            }
        });
    },

    _images : function() {
        let self = this;

        return {
            sortable : true,
            options  : {
                url                : '/api/socials/images/create/?api_token=' + auth.user.api_token + '&mode=profile',
                addRemoveLinks     : true,
                paramName          : 'image',
                thumbnailWidth     : 78,
                thumbnailHeight    : 78,
                maxFilesize        : 10,
                maxFiles           : 20,
                acceptedFiles      : 'image/*',
                timeout            : 180000,

                dictDefaultMessage : 'Чтобы загрузить изображение, выберите или просто перетащите его в это поле',
                maxfilesexceeded   : function(file) {
                    //this.removeAllFiles();
                    //this.addFile(file);
                }
            },
            complete : function(file, response, dropzone, item){
                let $file = $(file._removeLink).parent();
                if (response && response.error) return;

                if (!file.plan) {
                    file.plan = response ? response.plan : null;
                }
                if (!file.image){
                    file.image = response ? response.image : null;
                    if (file.image != null && (file.image.width < 1280 || file.image.height < 720)) {
                        file.image.disabled = true;

                        new Modal({
                            title: 		'Информация',
                            content: 	Utils.renderProfileTemplate('info', {
                                message   : 'Разрешение изображения не соответствует требованиям ВКонтакте, минимум 1280x720px',
                                buttons : {
                                    one : {
                                        class : 'confirm button--edit',
                                        title : 'Хорошо'
                                    },
                                    two : null
                                }
                            }),
                            confirm : function(args) {
                                let $modal = args.modal;
                                $modal.trigger('close');
                            }
                        });
                    }
                }

                let selected = $('#social-vk-params-form input[name="compilation[image]"]').val();

                if (file.pic) {
                    let path = file.pic;
                    $file.find('.dz-image').css('background-image', 'url(\'/' + file.pic + '\')');
                    $file.find('.dz-image').data('path', path);
                    $file.find('.dz-image img').remove();

                    if (selected == path)
                        $file.find('.dz-image').addClass('selected');
                }

                if (file.image) {
                    let path = (file.image.path_to_extra_large != '') ? file.image.path_to_extra_large : file.image.path_to_original;
                    $file.find('.dz-image').css('background-image', 'url(\'/' + (file.image.path_to_small != '' ? file.image.path_to_small : file.image.path_to_original) + '\')');
                    $file.find('.dz-image').data('path', path);
                    $file.find('.dz-image img').remove();

                    if (file.image.disabled)
                        $file.find('.dz-image').addClass('disabled');

                    if(selected == path)
                        $file.find('.dz-image').addClass('selected');
                }

                self._bindUI();
            },
            done: function(dropzone, item){
                let selected = null;
                if (item && item.params && item.params.params) {
                    let params = JSON.parse(item.params.params);
                    if (params.length && params[0].image) {
                        selected = params[0].image;
                        let file = { name: '', size: 1 };
                        dropzone.emit('addedfile', file);
                        file.pic = params[0].image;
                        dropzone.emit('processing', file);
                        dropzone.emit('complete', file);
                        dropzone.files.push(file);
                    }
                }

                self._args.response.images && self._args.response.images.forEach(function(image) {
                    let path = image.path_to_extra_large != '' ? image.path_to_extra_large : image.path_to_original;
                    if (selected != null && path == selected) return;

                    let file = { name: '', size: 1 };
                    dropzone.emit('addedfile', file);
                    file.image = image;
                    dropzone.emit('processing', file);
                    dropzone.emit('complete', file);
                    dropzone.files.push(file);
                });
            }
        }
    },

    get : function(args) {
        let self = this;

        self._setArgs(args);

        self._state.items.images = self._images();

        return self._state.items;
    },
}